import coreApiClient from "@/providers/core-api/CoreApi"

export default {
  store(message, socketId = null, workspaceId = null, conversationId = null, vehicleBrand = null, buyerType = null) {
    let payload = {
      content: message,
      conversation_id: conversationId,
      workspace_id: workspaceId,
      vehicle_brand: vehicleBrand,
      buyer_type: buyerType
    }

    for (let key in payload) {
      if (payload[key] === null) {
        delete payload[key]
      }
    }

    let headers = {}
    if (socketId) {
      headers["socket-id"] = socketId
    }

    return coreApiClient.sendRequest("post", "/v1/messages", payload, headers)
  }
}
